import Vue from 'vue';
import VueSwal from 'vue-swal';
import App from './App.vue';
import axios from 'axios';
import './index.css';
import router from './router';
import './registerServiceWorker';
import Multiselect from 'vue-multiselect';

Vue.use(VueSwal);
Vue.component('multiselect', Multiselect);

Vue.config.productionTip = false

let baseUrl = "https://staging.hrms.property-pistol.in/api/mobile_crm";
if(process.env.NODE_ENV === 'production'){
  baseUrl = "https://hr.propertypistol.in/api/mobile_crm"
}

axios.defaults.baseURL = baseUrl;

axios.interceptors.request.use(function(config) {
  if(config.url.indexOf('login') < 0 ){
    let token = localStorage.getItem('ipl-user-token');
    if(token){
      config.headers.Authorization = `Token token=${token}`
    }else{
      return {
        headers: {},
        method: config.method,
        url: ""
      };
    }
  }
  config.headers['Content-Type'] = 'application/json'
  config.headers['Accept'] = 'application/json'
  return config;
}, function(err) {
  return Promise.reject(err);
});

axios.interceptors.response.use(function(response) {
  return response;
}, function(error){
  if(error.response.status === 401){
    localStorage.removeItem('ipl-user-token');
    localStorage.removeItem('ipl-user-email');
    localStorage.removeItem('ipl-user-name');
    Vue.$swal({
      title: "Session Expired",
      text: "You have been redirected to the login page",
      icon: "error"
    })
    .then(()=>router.replace('/login'));
    return Promise.reject('');
  }else{
    return error.response ? Promise.reject(error.response) : Promise.reject(error);
  }
});
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('ipl-user-token')
  if(token && to.name === 'Login'){
    next({name: 'Home'});
  }else if(to.name !== 'Login' && !token){
    next({name: 'Login'});
  }else{
    next();
  }
})

Vue.prototype.$axios = axios;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

